import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Switch, Redirect } from "react-router-dom"
import styled from 'styled-components'
import PrivateRoute from "@src/components/router/private"
import RedirectWithStatus from "@src/components/router/redirect_with_status"
import Error from "@src/components/error/"
import PageNotFound from "@src/pages/404/"
import PersonalSettings from "./pages/personal"
import Security from "./pages/security"
import Apps from "./pages/apps"
import Notifications from "./pages/notifications"
import Roles from "./pages/roles"
import Team from "./pages/team"
import Organization from "./pages/organization"
import Billing from "./pages/billing"
import AsperaDownloads from "./pages/aspera"
import Sidebar from "./components/sidebar"
import Branding from "./pages/branding"
import { getSettingsAccess } from "./components/links"

const ContentContainer = styled.div`
  margin-left: 240px;
`

// Pages the user's role does not permit send them back to the default settings page.
const guardedRoute = (allowed, path, component) => allowed
  ? <PrivateRoute key={path} path={path} component={component}/>
  : <Redirect key={path} from={path} to='/settings/apps'/>

const Settings = ({ match, access }) => (
  <div>
    <Sidebar/>
    <Error>
      <ContentContainer className='flex-auto max-width-4 p2'>
        <Switch>
          <RedirectWithStatus status={301} exact from={match.path} to={`${match.path}/apps`}/>
          <Redirect exact from={`${match.path}/organization`} to ={`${match.path}/team`}/>
          <PrivateRoute path={`${match.path}/apps`} component={Apps}/>
          <PrivateRoute path={`${match.path}/profile`} component={PersonalSettings}/>
          <PrivateRoute path={`${match.path}/security`} component={Security}/>
          <PrivateRoute path={`${match.path}/notifications`} component={Notifications}/>
          {guardedRoute(access.usersAndRoles, `${match.path}/roles`, Roles)}
          {guardedRoute(access.usersAndRoles, `${match.path}/users`, Team)}
          {guardedRoute(access.teamProfile, `${match.path}/team`, Organization)}
          {guardedRoute(access.billing, `${match.path}/plans`, Billing)}
          {guardedRoute(access.billing, `${match.path}/billing`, Billing)}
          {guardedRoute(access.asperaEntitlements, `${match.path}/aspera`, AsperaDownloads)}
          {guardedRoute(access.screenersCustomization, `${match.path}/screeners`, Branding)}
          <PrivateRoute component={PageNotFound}/>
        </Switch>
      </ContentContainer>
    </Error>
  </div>
)

Settings.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired
  }).isRequired,
  access: PropTypes.objectOf(PropTypes.bool).isRequired
}

const mapStateToProps = (state, ownProps) => ({
  access: getSettingsAccess(state.user, state.user.organization)
})

export default connect(mapStateToProps)(Settings)
